import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const surveyResultsRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "survey-results/$surveyId",
}).lazy(() => import("./SurveyResults.lazy").then((d) => d.Route));
